// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
    jQuery(document).ready(function () {
        if ($('.hero-fluent-images').length > 0) {
            $('.hero-fluent-images').each(function () {
                var vm = $(this);
                $(window).on('load',function () { 
                var imageLeft = vm.find('.hero-fluent-images-spot > div:first-of-type');
                var imageRight = vm.find('.hero-fluent-images-spot > div:last-of-type');
    
                imageLeft.imagesLoaded().fail(function () {
                    vm.find('.hero-fluent-images-spot').removeClass('absolute-class');
                    imageRight.find('.image-wrapper').css({ 'right': '0' });
                    imageLeft.find('.image-wrapper').remove();
                    heroFluentImages(vm);
                    $(window).on('resize',function () {
                        heroFluentImages(vm);
                    });
                });
                imageRight.imagesLoaded().fail(function () {
                    vm.find('.hero-fluent-images-spot').removeClass('absolute-class');
                    imageLeft.find('.image-wrapper').css({ 'left': '0' });
                    imageRight.find('.image-wrapper').remove();
                    heroFluentImages(vm);
                    $(window).on('resize',function () {
                        heroFluentImages(vm);
                    });
                });
                    vm.imagesLoaded().done(function () {
                        heroFluentImages(vm);
                        $(window).on('resize', function () {
                            heroFluentImages(vm);
                        });
                    }); 
                });
            });    
        }
        
    });
})(window, document, jQuery);

function heroFluentImages(vm) {

    var imagePaddingInPixels = vm.data("image-padding");
    if (imagePaddingInPixels === undefined) {
        imagePaddingInPixels = 0;

    }

    var previousSpot = GetPreviousVisibleSpot(vm);
    var previousSpotPadding = previousSpot.data("image-padding");
    if (previousSpotPadding === undefined || (!previousSpotPadding)) {
        previousSpotPadding = 0;
    }

    var nextSpot = GetNextVisibleSpot(vm);
    var nextSpotPadding = nextSpot.data("image-padding");
    if (nextSpotPadding === undefined || (!nextSpotPadding)) {
        nextSpotPadding = 0;
    }
    
    if (imagePaddingInPixels >= previousSpotPadding) {
        vm.css('padding-top', imagePaddingInPixels);
    }

    if (imagePaddingInPixels > nextSpotPadding) {
        vm.css('padding-bottom', imagePaddingInPixels);
    }

    // save both images to variables
    var imageLeft = vm.find('.hero-fluent-images-spot > div').eq(0);
    var imageRight = vm.find('.hero-fluent-images-spot > div').eq(1);
    
    // remove tags if empty
    if (imageLeft.find('.itemTag').text().trim().length === 0) {
        imageLeft.find('.itemTag').remove();
    }
    if (imageRight.find('.itemTag').text().trim().length === 0) {
        imageRight.find('.itemTag').remove();
    }
    // save width of right and left image
    var gridLeft = imageLeft.width();
    var gridRight = imageRight.width();

    var remainingWidth = (vm.width() - vm.find('.hero-fluent-images-spot').width()) / 2;
    var margins = vm.hasClass('no_white_space') ? 0 : 20;
    var maxHeight = 0;
    var leftGridWidth = 0;
    var rightGridWidth = 0;
    var leftUrl = imageLeft.find('.mainLink').attr('href');
    var rightUrl = imageRight.find('.mainLink').attr('href');

    if (leftUrl) {
        if (leftUrl.length < 2) {
            imageLeft.find('.mainLink').click(function (e) { e.preventDefault(); });
        }
    }
    if (rightUrl) {
        if (rightUrl.length < 2) {
            imageRight.find('.mainLink').click(function (e) { e.preventDefault(); });
        }
    }

    if (imageLeft.hasClass('grid_12')) {
        vm.find('.hero-fluent-images-spot').removeClass('absolute-class');
        imageRight.remove();
        imageLeft.find('.image-wrapper').width(vm.width() - imagePaddingInPixels * 2);
        imageLeft.find('.mainLink').width(vm.width() - imagePaddingInPixels * 2);
        imageLeft.find('.image-wrapper').css({ 'left': imagePaddingInPixels });
        imageLeft.find('.article-wrapper').css({ 'left': imagePaddingInPixels });

        var fluentText = vm.find('.fluent-text');
        var fluentTextInside = vm.find('.fluent-text').children();
        if (fluentTextInside.text().length > 0) {
            fluentText.show();

            if (vm.width() < 768) {
                
                vm.find('.hero-fluent-images-spot').css('min-height', '50px');
                fluentTextInside.css('position', 'relative');
                fluentTextInside.css('padding', '10px');

                var widthModifier = imageLeft.width() - Number(fluentTextInside.css('padding-left').substr(0, fluentTextInside.css('padding-left').length - 2)) * 2;
                fluentTextInside.width(widthModifier);

            } else {
                
                vm.find('.hero-fluent-images-spot').css('min-height', '');
                fluentTextInside.css({'position':'', 'padding':''});

                var widthModifier = imageLeft.width() - Number(fluentTextInside.css('padding-left').substr(0, fluentTextInside.css('padding-left').length - 2)) * 2;
                fluentTextInside.width(widthModifier);

                var heightModifier = fluentTextInside.height() + Number(fluentTextInside.css('padding-top').substr(0, fluentTextInside.css('padding-top').length - 2)) - 50;

                fluentText.height(heightModifier);
                fluentTextInside.css('margin-top', '-70px');
                vm.find('.article-wrapper.Bottom').css('padding-bottom', '70px');
                
            }

        } else {
            fluentText.remove();
        }
    } else {

        var completeImagePadding = imagePaddingInPixels * 3;
        var leftImagePadding = Math.floor(completeImagePadding / 2);
        var rightImagePadding = completeImagePadding - leftImagePadding;

        leftGridWidth = gridLeft + remainingWidth + margins - leftImagePadding;
        rightGridWidth = vm.width() - (gridLeft + remainingWidth + margins + rightImagePadding);

        imageLeft.find('.image-wrapper').width(leftGridWidth);
        imageRight.find('.image-wrapper').width(rightGridWidth);
        imageLeft.find('.mainLink').width(leftGridWidth);
        imageRight.find('.mainLink').width(rightGridWidth);
        if (vm.find('.hero-fluent-images-spot').hasClass('absolute-class')) {
            imageLeft.find('.article-wrapper').width(leftGridWidth - margins);
            imageRight.find('.article-wrapper').width(rightGridWidth - margins);
            imageLeft.find('.article-wrapper').css({ 'left': imagePaddingInPixels });
        }
    }

    maxHeight = Math.max(imageLeft.find('img').height(), imageRight.find('img').height())-1;
    if (vm.width() < 768) {
        if (maxHeight < 50) {
            imageLeft.height(250);
            imageRight.height(250);
            vm.find('.mainLink').height(250);
        } else {
            imageLeft.height(maxHeight);
            imageRight.height(maxHeight);
            vm.find('.mainLink').height(maxHeight);
        }
        //fix the left image
        if (maxHeight > imageLeft.find('img').height()) {
            imageLeft.addClass('mobile-fluent');
        }
        if (imageLeft.find('img').height() > imageLeft.children('.article-wrapper').height()) {
            imageLeft.addClass('mobile-fluent');
            imageLeft.height('auto');
            imageLeft.children('.article-wrapper').css('position', 'absolute');
        } else {
            imageLeft.addClass('mobile-fluent');
            imageLeft.children('.article-wrapper').css('position', '');
        }
        //fix the right image
        if (maxHeight > imageRight.find('img').height()) {
            imageRight.addClass('mobile-fluent');
        }
        if (imageRight.find('img').height() > imageRight.children('.article-wrapper').height()) {
            imageRight.addClass('mobile-fluent');
            imageRight.height('auto');
            imageRight.children('.article-wrapper').css('position', 'absolute');
        } else {
            imageRight.addClass('mobile-fluent');
            imageRight.children('.article-wrapper').css('position', '');
        }
    } else {
        imageLeft.children('.article-wrapper').css('position', '');
        imageRight.children('.article-wrapper').css('position', '');
        imageLeft.css('height', '');
        imageRight.css('height', '');
        imageLeft.removeClass('mobile-fluent');
        imageRight.removeClass('mobile-fluent');
        if ((vm.width() > 300) && (maxHeight < 50)) {
            vm.find('.hero-fluent-images-spot').height(250);
            vm.find('.mainLink').height(250);
        } else {
            vm.find('.hero-fluent-images-spot').height(maxHeight);
            vm.find('.mainLink').height(maxHeight);
        }
    }
    
    vm.css({ 'visibility': 'visible' });

    /*
     * check height of texts and equal the heights
     */
    var _b = '.headingBackground.Bottom h1';
    var bottoms = vm.find(_b);
    var _t = '.headingBackground.Top h1';
    var tops = vm.find(_t);

    if (vm.width() >= 768) {
        if (bottoms.length === 2) {
            bottoms.height(Math.max(imageLeft.find(_b).height(), imageRight.find(_b).height()));
        }
        if (tops.length === 2) {
            tops.height(Math.max(imageLeft.find(_t).height(), imageRight.find(_t).height()));
        }
    } else {
        bottoms.css("height", "auto");
        tops.css("height", "auto");
    }
}

function GetPreviousVisibleSpot(currentSpot) {
    var previousSpot = currentSpot.prev();
    if (previousSpot.css("display") == "none" || previousSpot.css("visible") == "false") {
        return GetPreviousVisibleSpot(previousSpot);
    }

    return previousSpot;
}

function GetNextVisibleSpot(currentSpot) {
    var nextSpot = currentSpot.next();
    if (nextSpot.css("display") == "none" || nextSpot.css("visible") == "false") {
        return GetNextVisibleSpot(nextSpot);
    }

    return nextSpot;
}